import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { useLenis } from "@/lib/useLenis";
import { Navbar } from "@/components/lasercut/Navbar";
import { Hero } from "@/components/lasercut/Hero";
import { EditorialMarquee } from "@/components/lasercut/EditorialMarquee";
import { Manifesto } from "@/components/lasercut/Manifesto";
import { Process } from "@/components/lasercut/Process";
import { Catalog } from "@/components/lasercut/Catalog";
import { Portfolio } from "@/components/lasercut/Portfolio";
import { CustomRequest } from "@/components/lasercut/CustomRequest";
import { Contact } from "@/components/lasercut/Contact";
import { Footer } from "@/components/lasercut/Footer";
import { DocPage } from "@/components/lasercut/DocPage";

const Landing = () => {
  const [presetCategory, setPresetCategory] = useState("");

  const handleSelectCategory = (slug) => {
    setPresetCategory(slug);
    document.getElementById("konsultasi")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App font-body bg-ink">
      <div className="noise-overlay" />
      <Navbar />
      <Hero />
      <Manifesto />
      <EditorialMarquee />
      <Process />
      <Catalog onSelectCategory={handleSelectCategory} />
      <Portfolio />
      <CustomRequest presetCategory={presetCategory} />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  useLenis();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/riset" element={<DocPage mdPath="/docs/riset-bisnis.md" />} />
        <Route path="/strategi" element={<DocPage mdPath="/docs/strategi-sales-marketing.md" />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
